import type { LineItemData } from './LineItemList';
import type { ProjectData } from './LineItemList';
import type { Rates } from '@jobos/shared';
import type { FlatItem } from './types';
import { useHistory, type UseHistoryReturn } from '@/hooks/useHistory';

export interface Snapshot {
  flatItems: FlatItem[];
  jobRates: Rates;
  roundingPrecision: number | null;
}

export function cloneSnapshot(snapshot: Snapshot): Snapshot {
  return {
    flatItems: snapshot.flatItems.map(item => ({
      ...item,
      data: item.type === 'project-header'
        ? {
            ...(item.data as ProjectData),
            lineItems: (item.data as ProjectData).lineItems.map(li => ({
              ...li,
              subItems: li.subItems.map(sub => ({ ...sub })),
            })),
          }
        : {
            ...(item.data as LineItemData),
            subItems: (item.data as LineItemData).subItems.map(sub => ({ ...sub })),
          },
    })),
    jobRates: { ...snapshot.jobRates },
    roundingPrecision: snapshot.roundingPrecision,
  };
}

export function useUndoHistory(): UseHistoryReturn<Snapshot> {
  return useHistory<Snapshot>({ clone: cloneSnapshot });
}
